import React from "react";
import { VStack } from "@chakra-ui/react";
import { generateCaseTimeInterval, useCurrentCase } from "duck";
import {
  CommentsSection,
  FluidsAndTemperature,
  GasAndOxygen,
  MonitoringBy,
  Vitals
} from "./components";

const Anesthesia: React.FC = () => {
  const { createdAt, procedures } = useCurrentCase(medicalCase => ({
    createdAt: medicalCase.data.createdAt,
    procedures: medicalCase.data.client?.patient?.patientProcedures
  }));
  const anesthesia = procedures?.find(
    procedure => procedure.name === "Anesthesia"
  );
  const fluidsTimeIntervals = generateCaseTimeInterval(
    anesthesia?.startTime ?? createdAt,
    15
  );
  const gasTimeIntervals = generateCaseTimeInterval(
    anesthesia?.startTime ?? createdAt,
    5
  );
  const vitalsTimeIntervals = generateCaseTimeInterval(
    anesthesia?.startTime ?? createdAt,
    5
  );

  return (
    <VStack spacing="12" alignItems="left">
      <MonitoringBy />
      <FluidsAndTemperature timeIntervals={fluidsTimeIntervals} />
      <GasAndOxygen timeIntervals={gasTimeIntervals} />
      <Vitals timeIntervals={vitalsTimeIntervals} />
      <CommentsSection />
    </VStack>
  );
};

export default Anesthesia;
